import * as H from 'history';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import { ISupplier, IPublicPrice, IFullPublicPrice } from 'src/common-types/index';
import {
  ROOMS_SEARCH_LABEL,
  Routes,
  SESSION_KEY_LABEL_ROOMS,
  TOP_SUPPLIERS,
  countriesCode,
} from 'src/constants/index';
import { UrlUtils } from './urls';

export const getTopSuppliers = (
  prices: IPublicPrice[] = [],
  suppliers: ISupplier[],
): IFullPublicPrice[] => {
  const res: IFullPublicPrice[] = [];
  const currentFullPrices: IFullPublicPrice[] = prices
    .map(({ price, supplierId }) => {
      const supplier = suppliers.find(({ id }) => id === supplierId);

      if (supplier) {
        return {
          supplier,
          price,
          supplierId,
        };
      }
    })
    .filter((item) => item !== undefined);

  TOP_SUPPLIERS.forEach((name: string) => {
    const supplier = currentFullPrices.find(
      (fullPrice) => fullPrice?.supplier?.displayName?.toLowerCase() === name.toLowerCase(),
    );

    if (supplier) {
      res.push(supplier);
    }
  });

  currentFullPrices.forEach((fullPrice: IFullPublicPrice) => {
    if (res.every((price: IFullPublicPrice) => price?.supplierId !== fullPrice?.supplierId)) {
      res.push(fullPrice);
    }
  });

  return res;
};

export const openHotelPage = (hotelId: number, history: H.History<H.LocationState>): void => {
  UrlUtils.removeFromUrl(ROOMS_SEARCH_LABEL);
  UrlUtils.removeFromUrl(SESSION_KEY_LABEL_ROOMS);

  history.push(`${Routes.Hotel}/${hotelId}/${location.search}`);
};

export const isNotEmpty = (data: string): boolean => {
  return !isUndefined(data) && !isEmpty(data);
};

export const getFullAddress = (
  address: string,
  city: string,
  state: string,
  zipCode: string,
  countryCode: string,
  countryName = '',
): string[] => {
  const defaultBehaviorItems: string[] = [address, city, state, zipCode, countryName];
  const fullAddress: string[] = [];

  defaultBehaviorItems.forEach((item: string) => {
    if (isNotEmpty(item)) {
      fullAddress.push(item);
    }
  });

  if (isNotEmpty(countryCode) && countryName === '') {
    const country = countriesCode.find(
      ({ isoCode }) => isoCode.toLowerCase() === countryCode.toLowerCase(),
    );

    if (country) {
      fullAddress.push(country.name);
    } else {
      fullAddress.push(countryCode);
    }
  }

  return fullAddress;
};
